import axios from 'axios'

const FIELDLIST = {
  mounted() {
    axios.get(`${this.$api}/current-date`).then((response) => {
      if (response.data.status === 'success') {
        this.$store.commit('setCurrentDate', response.data.currentDate)
      }
    }).catch((error) => {
      console.log(error)
    })
    axios.get(`${this.$api}/public-lists`).then((response) => {
      if (response.data.status === 'success') {
        // eslint-disable-next-line
        // console.log(response)
        this.$store.commit('updateCommittees', response.data.committees)
        this.$store.commit('updateDraftStatus', response.data.draftStatus)
        this.$store.commit('updateZones', response.data.zones)
        this.$store.commit('updateEventTypes', response.data.eventTypes)
        this.$store.commit('updateRiderStatus', response.data.riderStatus)
        this.$store.commit('updateHorseStatus', response.data.horseStatus)
        this.$store.commit('updateProducts', response.data.products)
        this.$store.commit('updateDiscounts', response.data.discounts)
        this.$store.commit('updateBlocks', response.data.blocks)
        this.$store.commit('setVehiclesTypes', response.data.vehicleTypes)
        this.$store.commit('setVehiclesSize', response.data.vehicleSizes)
      }
    }).catch((error) => {
      // eslint-disable-next-line
      console.log(error)
    })
  }
}

export default FIELDLIST



// WEBPACK FOOTER //
// ./src/mixins/getFieldLists.js